import React, { Component } from "react"
import Slider from "react-slick"
import "./index.css"

const LeftArrow = ({ style, onClick }) => {
  return (
    <button
      className={`spot-light-left-arrow`}
      onClick={onClick}
      style={{
        ...style,
      }}
    >
      <i
        style={{ fontSize: 80, color: "rgb(167, 167, 167, 0.8)" }}
        className="btn fa fa-caret-left"
      />
    </button>
  )
}

const RightArrow = ({ style, onClick }) => {
  return (
    <button
      className={`spot-light-right-arrow`}
      onClick={onClick}
      style={{
        ...style,
      }}
    >
      <i
        style={{ fontSize: 80, color: "rgb(167, 167, 167, 0.8)" }}
        className="btn fa fa-caret-right"
      />
    </button>
  )
}

class SpotLightSider extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 3,
      nextArrow: <RightArrow />,
      prevArrow: <LeftArrow />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    }

    return (
      <Slider {...settings}>
        <div>
          <div className="col home-spot-light-slide">
            <img
              className="img-fluid"
              src={require("../../../../images/Home/Woodstock-Showmotiv.png")}
              alt="slide-1"
            />
            <p className="date-time">16.12.2019, 20:00 Uhr</p>
            <p className="performer-name">Felix Martin</p>
            <p className="album">Das Weihnachtskonzert vol. 2</p>
          </div>
        </div>
        <div>
          <div className="col home-spot-light-slide">
            <img
              className="img-fluid"
              src={require("../../../../images/Home/Woodstock-Showmotiv.png")}
              alt="slide-1"
            />
            <p className="date-time">16.12.2019, 20:00 Uhr</p>
            <p className="performer-name">Felix Martin</p>
            <p className="album">Das Weihnachtskonzert vol. 2</p>
          </div>
        </div>
        <div>
          <div className="col home-spot-light-slide">
            <img
              className="img-fluid"
              src={require("../../../../images/Home/Woodstock-Showmotiv.png")}
              alt="slide-1"
            />
            <p className="date-time">16.12.2019, 20:00 Uhr</p>
            <p className="performer-name">Felix Martin</p>
            <p className="album">Das Weihnachtskonzert vol. 2</p>
          </div>
        </div>
        <div>
          <div className="col home-spot-light-slide">
            <img
              className="img-fluid"
              src={require("../../../../images/Home/Woodstock-Showmotiv.png")}
              alt="slide-1"
            />
            <p className="date-time">16.12.2019, 20:00 Uhr</p>
            <p className="performer-name">Felix Martin</p>
            <p className="album">Das Weihnachtskonzert vol. 2</p>
          </div>
        </div>
        <div>
          <div className="col home-spot-light-slide">
            <img
              className="img-fluid"
              src={require("../../../../images/Home/Woodstock-Showmotiv.png")}
              alt="slide-1"
            />
            <p className="date-time">16.12.2019, 20:00 Uhr</p>
            <p className="performer-name">Felix Martin</p>
            <p className="album">Das Weihnachtskonzert vol. 2</p>
          </div>
        </div>
        <div>
          <div className="col home-spot-light-slide">
            <img
              className="img-fluid"
              src={require("../../../../images/Home/Woodstock-Showmotiv.png")}
              alt="slide-1"
            />
            <p className="date-time">16.12.2019, 20:00 Uhr</p>
            <p className="performer-name">Felix Martin</p>
            <p className="album">Das Weihnachtskonzert vol. 2</p>
          </div>
        </div>
        <div>
          <div className="col home-spot-light-slide">
            <img
              className="img-fluid"
              src={require("../../../../images/Home/Woodstock-Showmotiv.png")}
              alt="slide-1"
            />
            <p className="date-time">16.12.2019, 20:00 Uhr</p>
            <p className="performer-name">Felix Martin</p>
            <p className="album">Das Weihnachtskonzert vol. 2</p>
          </div>
        </div>
        <div>
          <div className="col home-spot-light-slide">
            <img
              className="img-fluid"
              src={require("../../../../images/Home/Woodstock-Showmotiv.png")}
              alt="slide-1"
            />
            <p className="date-time">16.12.2019, 20:00 Uhr</p>
            <p className="performer-name">Felix Martin</p>
            <p className="album">Das Weihnachtskonzert vol. 2</p>
          </div>
        </div>
        <div>
          <div className="col home-spot-light-slide">
            <img
              className="img-fluid"
              src={require("../../../../images/Home/Woodstock-Showmotiv.png")}
              alt="slide-1"
            />
            <p className="date-time">16.12.2019, 20:00 Uhr</p>
            <p className="performer-name">Felix Martin</p>
            <p className="album">Das Weihnachtskonzert vol. 2</p>
          </div>
        </div>
      </Slider>
    )
  }
}

export default SpotLightSider
